import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../../data/site';
import { useReveal } from '../../hooks/useReveal';
import type { Pet } from '../../types';
import '../../styles/DetailContact.css';

interface DetailContactProps {
  pet: Pet;
}

const DetailContact: React.FC<DetailContactProps> = ({ pet }) => {
  const article = pet.kind === 'cat' ? 'a' : 'o';
  const subject = encodeURIComponent(
    `Quero conhecer ${article} ${pet.name} (ficha ${pet.ref})`,
  );
  const body = encodeURIComponent(
    `Olá Patinhas Sem Lar!

Vi a ficha ${article} ${pet.name} (${pet.ref}) no site e gostava de marcar uma visita.

Sobre mim:
— nome:
— onde vivo:
— se já tenho outros animais em casa:

Obrigada,
`,
  );
  const mailto = `mailto:${SITE.contact.email}?subject=${subject}&body=${body}`;

  const back =
    pet.kind === 'cat'
      ? { to: '/adotar/gatos', label: '← voltar aos gatos' }
      : { to: '/adotar/caes', label: '← voltar aos cães' };

  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`detail-contact psl-reveal${revealed ? ' is-in-view' : ''}`}
      id="contact-pet"
    >
      <div className="detail-contact__pattern" aria-hidden="true" />
      <div className="detail-contact__inner">
        <div className="detail-contact__chapter">— marcar visita</div>
        <h2 className="detail-contact__title">
          Acolher é um ato <em>devagar.</em><br />
          Vamos com calma?
        </h2>
        <p className="detail-contact__copy">
          Escreve-nos uma mensagem com algumas linhas sobre ti — onde vives, com
          quem, se há outros animais em casa. Respondemos em poucos dias e, se
          parecer um bom encaixe, marcamos uma visita ao abrigo.
        </p>

        <div className="detail-contact__cta-row">
          <a className="btn btn--primary" href={mailto}>
            Escrever sobre {pet.name} →
          </a>
        </div>

        <div className="detail-contact__back">
          <Link to={back.to}>{back.label}</Link>
        </div>
      </div>
    </section>
  );
};

export default DetailContact;
